/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';

import List from '../../components/List';
import { BodyMain } from '../../components/Text';
import { Button } from '../../components/buttons/Buttons';
import TextArea from '../../components/TextArea';

import ContentLoader from '../../components/ContentLoader';
import RouteNames from '../RouteNames';
import UserService from '../../../apiServices/UserService';
import AppUtils from '../../../utilities/AppUtils';

import './DeleteAccountSurvey.styles.scss';
import Card, { CardSection } from '../../components/card/Card';
import ContentWrapper from '../../components/ContentWrapper';
import ManageSession from '../../../utilities/ManageSession';
import { CardRowUI } from '../../../bphComponents/bundle';


class DeleteAccountSurvey extends React.Component {

  constructor(props) {
    super(props);

    this.onWriteComment = this.onWriteComment.bind(this);
    this.onToggleReason = this.onToggleReason.bind(this);
    this.deleteMyAccountForever = this.deleteMyAccountForever.bind(this);

    this.state = {
      commentText: '',
      isSubmitting: false,
      reasons: [],
      accountWasDeleted: false,
    };
  }

  onWriteComment(commentText) {
    this.setState({ commentText });
  }

  onToggleReason(reason, checked) {
    const reasons = this.state.reasons;
    this.setState({
      reasons: checked ? reasons.concat([reason]) : _.without(reasons, reason),
    });
  }

  deleteMyAccountForever() {
    const reasonIds = this.state.reasons.join(',');
    const cancelData = {
      cancellation_reasons_message: this.state.commentText,
      cancellation_reasons: reasonIds,
    };

    this.setState({ isSubmitting: true }, () => {
      UserService.del(this.props.userId, cancelData, (apiError) => {
        if (apiError) {
          this.setState({ isSubmitting: false });
          this.props.showNotification(apiError.messageKey());
          return;
        }

        ManageSession.cancelIdleTimer();

        AppUtils.logout({}, () => {
          this.setState({
            accountWasDeleted: true,
          });
        });
      });
    });
  }

  render() {
    if (this.state.accountWasDeleted) {
      return <Redirect to={RouteNames.deleteAccountSuccess()} />;
    }

    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            cancel={this.props.goBack}
            color="white"
          />

          <ContentLoader isContentLoaded={this.props.isDataLoaded} blockRenderUntilLoaded>
            <ContentFrame>
              <ScrollAwareScroller>
                <AppHeaderScrollableText
                  id="deleteAccountConfirm.title.text"
                />
                <ContentWrapper>
                  <Card>
                    <CardSection style={{ paddingBottom: 10 }}>
                      <div className="font-color-gsDark font-subhead">
                        <FormattedMessage id="deleteAccountSurvey.reason.field.label" />
                      </div>
                    </CardSection>

                    <List hasBorder paddingSize="large">
                      {
                        this.props.cancelReasons.map((reason, index) => (
                          <CardRowUI.SelectableRow
                            key={index}
                            isSelected={_.includes(this.state.reasons, reason.id)}
                            onClick={() => { this.onToggleReason(reason.id, !_.includes(this.state.reasons, reason.id)); }}
                            hasBottomBorder={true}
                            selectedClassName="fill-color-profile-highlight"
                          >
                            <BodyMain className="font-color-gsDarkest">
                              <FormattedMessage id={reason.key} />
                            </BodyMain>
                          </CardRowUI.SelectableRow>
                        ))
                      }
                    </List>

                    <CardSection style={{ padding: '5px 8px 8px 8px' }}>
                      <div className="cmp-deletesurvey-cancel-textarea">
                        <TextArea
                          value={this.state.commentText}
                          height="110px"
                          placeholder="deleteAccountSurvey.additionalReason.field.hint"
                          default
                          maxLength={1000}
                          onChange={(e) => { this.onWriteComment(e.target.value); }}
                        />
                      </div>
                    </CardSection>
                  </Card>

                  <Button
                    className="bkgd-color-csError font-body"
                    size="wide"
                    style={{ marginTop: 0 }}
                    onClick={this.deleteMyAccountForever}
                    isDisabled={this.state.isSubmitting}
                  >
                    <FormattedMessage id="deleteAccountSurvey.delete.button.label" />
                  </Button>
                </ContentWrapper>

              </ScrollAwareScroller>
            </ContentFrame>
          </ContentLoader>
        </ScrollAwareContext>
      </div>
    );
  }
}
DeleteAccountSurvey.propTypes = {
  isDataLoaded: PropTypes.bool,
  cancelReasons: PropTypes.arrayOf(PropTypes.object),
  goBack: PropTypes.func.isRequired,
  userId: PropTypes.number,
  showNotification: PropTypes.func,
};

export default DeleteAccountSurvey;
